import { baseApi } from "./apiConfig";

export const unsubscribeUser = async (email, subscriptionMode) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get("/portal/user/unsubscribeUser", {
      params: {
        emailId: email,
        subscriptionMode,
        _: timestamp,
      },
    });
    return response.data; // expects: { status: "Y" | "N", message: string }
    
  } catch (error) {
    console.error("Error in unsubscribeUser API:", error);
    throw error;
  }
};

